import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';

export interface FormVersionDTO {
  currentFormVersion: number;
}

@Injectable({
  providedIn: 'root'
})
export class DebuggingService {

  private readonly API_URL = `${environment.backend.host}/${environment.backend.context}/${environment.backend.version}`;
  private _isDebuggingEnabled: boolean;

  public toggle() {
    this._isDebuggingEnabled = !this._isDebuggingEnabled;
  }

  get isDebuggingEnabled() {
    return this._isDebuggingEnabled;
  }

  loadCurrentAntragVersion(): number {
    return +localStorage.getItem('debugVersion');
  }

  updateAntragFormVersion(newVersion: number) {
    localStorage.setItem('debugVersion', `${newVersion}`);
  }
}
